import { render, staticRenderFns } from "./PedometerSimple.vue?vue&type=template&id=23a5858c&scoped=true&"
import script from "./PedometerSimple.vue?vue&type=script&lang=js&"
export * from "./PedometerSimple.vue?vue&type=script&lang=js&"
import style0 from "./PedometerSimple.vue?vue&type=style&index=0&id=23a5858c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a5858c",
  null
  
)

export default component.exports